import {NavLink} from 'react-router-dom';
import './Nav.scss';

// let x = ...

const Nav = ({
	setEntering, setSubmitting, setFetchedVisible
}) => {

	// fx() {}
	// fx = () => {};
	// let x = 1;
	const cleanInputsFx = (e) => {
    e.preventDefault();;
    setEntering({
      food: '',
      town: ''
    });
		setSubmitting({
      food: '',
      town: ''
    });
    setFetchedVisible(false);
  };

	return (
		<nav className="Nav">
			
			<ul>
        <li onClick={cleanInputsFx}><NavLink to="/">homepage</NavLink></li>
				<li>
          <a 
            href="https://www.yelp.com/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            real Yelp's site&nbsp;
            <svg 
              id="redirect-arrow" 
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 98.8 99"
            >
              <path 
                d="M73.9 51v29.9c0 10-8.1 18.1-18.1 18.1H18.1C8.1 99 0 90.9 0 80.9V43.2c0-10 8.1-18.1 18.1-18.1H48c1.7 0 3 1.3 3 3s-1.3 3-3 3H18.1C11.4 31.1 6 36.5 6 43.2v37.7C6 87.6 11.4 93 18.1 93h37.7c6.7 0 12.1-5.4 12.1-12.1V51c0-1.7 1.3-3 3-3s3 1.4 3 3zm-16-51c-1.7 0-3 1.3-3 3s1.3 3 3 3h30.4L35.6 58.7c-1.2 1.2-1.2 3.1 0 4.2.6.6 1.4.9 2.1.9s1.5-.3 2.1-.9l53-53V41c0 1.7 1.3 3 3 3s3-1.3 3-3V0H57.9z"
              />
            </svg>
          </a>

        </li>
      </ul>
		</nav>
	)
	
};

export default Nav;
